import React from 'react'
import { Link } from 'react-router-dom'
import { 
  FaLeaf, 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaYoutube,
  FaWhatsapp 
} from 'react-icons/fa'
import { siteInfo, navigationMenu } from '../data/siteData'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-12 h-12 bg-primary-500 rounded-full">
                  <FaLeaf className="text-xl text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold">SCOOP</h3>
                  <p className="text-gray-400">CG 1 GEA R.SL</p>
                </div>
              </div>
              <p className="text-gray-300 mb-6 leading-relaxed">
                {siteInfo.description}
              </p>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                >
                  <FaFacebook />
                </a>
                <a 
                  href="https://www.twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                >
                  <FaTwitter />
                </a>
                <a 
                  href="https://www.linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                >
                  <FaLinkedin />
                </a>
                <a 
                  href="https://www.youtube.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-300"
                >
                  <FaYoutube />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Navigation</h4>
              <ul className="space-y-3">
                {navigationMenu.map((item, index) => (
                  <li key={index}>
                    <Link 
                      to={item.path}
                      className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Contact</h4>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <FaMapMarkerAlt className="text-primary-400 flex-shrink-0" />
                  <span className="text-gray-300">{siteInfo.address}</span>
                </div>
                <div className="flex items-center space-x-3">
                  <FaPhone className="text-primary-400 flex-shrink-0" />
                  <a 
                    href={`tel:${siteInfo.phone}`}
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                  >
                    {siteInfo.phone}
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <FaEnvelope className="text-primary-400 flex-shrink-0" />
                  <a 
                    href={`mailto:${siteInfo.email}`}
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                  >
                    {siteInfo.email}
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <FaWhatsapp className="text-primary-400 flex-shrink-0" />
                  <a 
                    href="https://wa.me/22177658032"
                    className="text-gray-300 hover:text-primary-400 transition-colors duration-300"
                  >
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="bg-gray-800 py-8">
        <div className="container-custom">
          <div className="text-center">
            <h4 className="text-xl font-semibold mb-4">Restez informés</h4>
            <p className="text-gray-300 mb-6">
              Inscrivez-vous à notre newsletter pour recevoir nos actualités
            </p>
            <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Votre adresse email"
                className="w-full px-4 py-3 rounded-lg bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              <button className="w-full sm:w-auto btn-primary whitespace-nowrap">
                S'inscrire
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-950 py-6">
        <div className="container-custom">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {siteInfo.name}. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm">
              <Link 
                to="/mentions-legales" 
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Mentions légales
              </Link>
              <Link 
                to="/politique-confidentialite" 
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Politique de confidentialité
              </Link>
              <Link 
                to="/cookies" 
                className="text-gray-400 hover:text-primary-400 transition-colors duration-300"
              >
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 